import axios from '../lib/axios';

export const getDeals = async (params = {}) => {
    const { data } = await axios.get('/api/deals', { params });
    return data;
};

export const getDealsPipeline = async () => {
    const { data } = await axios.get('/api/deals/pipeline');
    return data;
};

export const getDeal = async (id) => {
    const { data } = await axios.get(`/api/deals/${id}`);
    return data;
};

export const createDeal = async (dealData) => {
    const { data } = await axios.post('/api/deals', dealData);
    return data;
};

export const updateDeal = async ({ id, ...dealData }) => {
    const { data } = await axios.put(`/api/deals/${id}`, dealData);
    return data;
};

export const deleteDeal = async (id) => {
    const { data } = await axios.delete(`/api/deals/${id}`);
    return data;
};

export const moveDealStage = async (id, stage) => {
    const { data } = await axios.patch(`/api/deals/${id}/move-stage`, { stage });
    return data;
};
